import { render, staticRenderFns } from "./UserSearchComponent.vue?vue&type=template&id=2ab4bdeb&scoped=true&"
import script from "./UserSearchComponent.vue?vue&type=script&lang=js&"
export * from "./UserSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserSearchComponent.vue?vue&type=style&index=0&id=2ab4bdeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4bdeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VAvatar,VChip,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
